module.exports = __webpack_public_path__ + "static/media/add_note_icon.f7b3d4f7.svg";